import React from 'react'
import Draggable from "../../../DnD/Draggable";
import classNames from "classnames";
function Text({id, name, className}) {
    return (
        <Draggable id={id}>
            <div className={classNames("text", className)}>{name}</div>
        </Draggable>
    )
}

export default Text
